module.exports = __webpack_public_path__ + "static/media/5-hybrid.1c2023f9.png";